var React = require('react');

function FlagNetherlands (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M23 0H0.5V15H23V0Z","fill":"#21468B","key":0}),React.createElement("path",{"d":"M23 0H0.5V10H23V0Z","fill":"white","key":1}),React.createElement("path",{"d":"M23 0H0.5V5H23V0Z","fill":"#AE1C28","key":2})]);
}

FlagNetherlands.defaultProps = {"width":"23","height":"15","viewBox":"0 0 23 15","fill":"none"};

module.exports = FlagNetherlands;

FlagNetherlands.default = FlagNetherlands;
